import React from 'react';
import { captureException } from '../services/analytics';

export class ErrorBoundary extends React.Component {
  componentDidCatch(error, info) {
    captureException(error, { component_stack: info.componentStack });
  }

  render() {
    return this.props.children;
  }
}
